import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
export const getShareImagePlatform = ()=>{
    if (UIUtilsEjsVariables.isUserOnDiscord) return 'discord';
    if (UIUtilsEjsVariables.isUserOnMobile) return 'mobile';
    return 'desktop';
};
export const createInitialShareImageFooter = (platform, options)=>{
    if (platform == 'desktop') return {
        layout: 'copyAndDownload',
        copyButtonState: 'copy'
    };
    if (platform == 'discord') {
        return {
            layout: 'shareOnly',
            shareButtonLabel: {
                key: 'strings:game.endGame.cornerButton.share'
            }
        };
    }
    return {
        layout: 'shareWithOptionalReplay',
        shareButtonLabel: {
            key: 'strings:game.endGame.shareImagePopup.mobile.shareImageButtonText'
        },
        showReplayButton: options.hasReplayShare
    };
};
